import { render, staticRenderFns } from "./SpecialMenuHeader.vue?vue&type=template&id=f492c2be&scoped=true&"
import script from "./SpecialMenuHeader.vue?vue&type=script&lang=js&"
export * from "./SpecialMenuHeader.vue?vue&type=script&lang=js&"
import style0 from "./SpecialMenuHeader.vue?vue&type=style&index=0&id=f492c2be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f492c2be",
  null
  
)

export default component.exports